import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import NodeArticleTeaser from './Teaser';
import NodeArticlePage from './Page';
import { NodeArticle } from '../../../types/uncinc_profile/nodes';

interface NodeArticleProps {
  entity: ImmutableEntity<NodeArticle>;
  viewMode: string;
  highlighted?: boolean;
  large?: boolean;
}

const NodeArticleWrapper: React.FC<NodeArticleProps> = ({
  entity, viewMode, highlighted, large,
}) => {
  switch (viewMode) {
    case 'teaser':
      return <NodeArticleTeaser entity={entity} highlighted={highlighted} large={large} />;
    default:
      return <NodeArticlePage entity={entity} />;
  }
};

export default NodeArticleWrapper;
